<template>
  <div class="account">
    <GlobalInfoBar title="投保单列表" />
    <GlobalChunk :padding="[20, 20, 20, 20]">
      <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :inline="true" round
        @handleConfirm="query" confirmBtnName="查询" :label-width="90">
        <el-form-item class="el_from" label="IMEI:" slot="imei" style="margin:0">
          <el-input v-model="imei" clearable placeholder="请输入IMEI查询"></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="联系电话:" slot="phone" style="margin:0">
          <el-input v-model="phone" clearable placeholder="请输入联系电话查询"></el-input>
        </el-form-item>
        <el-form-item class="el_from" label="订单状态:" slot="status" style="margin:0">
          <el-select clearable v-model="status" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <div slot="AddSlot">
          <el-button type="primary" size="mini" @click="tableExport">列表导出</el-button>
        </div>
      </GlobalForm>

      <GlobalTable ref="GlobalTable" :columns="tableColumns" :data="tableData" :currentPage="curPage"
        :total="totalElements" @handleCurrentChange="currentChange">
        <el-table-column label="操作" slot="operation" align="center" fixed="right">
          <template slot-scope="{ row }">
            <!-- <el-button type="text" size="mini" @click="seeDetails(row)">查看详情</el-button> -->
            <el-button type="text" size="mini" @click=" supplModelRowShow = true, supplModelForm = row">操作</el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog title="补充机型" :visible.sync="supplModelRowShow" :close-on-click-modal="false" width="600px"
      @close="supplModelRowShow = false, supplModelForm = {}, brand = '',getList()">
      <div style="margin-left: 10px;">串码：{{ supplModelForm.imei }}</div>
      <div>
        <div style="margin: 15px 10px;">
          查询品牌：<el-select v-model="brand" placeholder="请选择">
            <el-option v-for="item in supplModelOptions" :key="item.name" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
          <el-button type="primary" :loading="loading" style="margin-left: 10px;" @click="queryBrand()">查询</el-button>
        </div>
        <div style="color: red;margin: 10px;font-size: 12px;">
          注：序列号查询，请选择好查询品牌。
        </div>
        <el-form ref="form" :model="supplModelForm" label-width="80px">
          <el-form-item label="终端品牌">
            <el-input v-model="supplModelForm.terminalBrand"></el-input>
          </el-form-item>
          <el-form-item label="终端机型">
            <el-input v-model="supplModelForm.termianlModel"></el-input>
          </el-form-item>
        </el-form>
        <div style="display: flex;justify-content: flex-end;padding: 15px;">
          <el-button @click="supplModelRowShow = false, supplModelForm = {}, brand = ''">取消</el-button>
          <el-button type="primary" @click="supplModelSubmit()">确认</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import environments from '../../config/url'
import api from '@/utils/request'
import { perClaimRemark } from "../../utils/request";
export default {
  name: "account",
  data() {
    return {
      options: [

        {
          value: 1,
          label: '审核通过'
        }, {
          value: 2,
          label: '审核不通过'
        }, {
          value: 3,
          label: '退保'
        }],
      status: null,
      initData: {},
      formRules: {},
      formItemList: [
        { slotName: "imei" },
        { slotName: "phone" },
        {
          key: "entryTime",
          type: "daterange",
          labelName: "时间:",
          placeholder: "请选择时间",
          valueFormat: "timestamp",
        },
        { slotName: "status" },
      ],
      imei: '',
      phone: '',
      beg_time: '',
      end_time: '',
      tableColumns: [
        // { label: "承保单ID", prop: "order_id" },
        { label: "产品编号", prop: "productCode" },
        { label: "迪信通编号", prop: "policyId" },
        { label: "服务购买时间", prop: "insuranceTime" },
        { label: "保险生效时间", prop: "effTime" },
        { label: "保险失效时间", prop: "expTime" },
        { label: "imei", prop: "imei" },
        { label: "品牌", prop: "terminalBrand" },
        { label: "机型", prop: "termianlModel" },
        { label: "姓名", prop: "userName" },
        { label: "手机号", prop: "mobilePhone" },
        { label: "添加时间", prop: "addTime" },
        { label: "人保保单号", prop: "policyNo" },
        { label: "订单状态", prop: "orderStatusName" },
        { label: "失败描述", prop: "orderDesc" },
        { label: "小集团", prop: "xjt" },
        { label: "门店", prop: "store" },
        { label: "员工", prop: "salesMan" },
        { slotName: 'operation' },
      ],
      tableData: [],
      curPage: 1,
      totalElements: 0,
      pageSize: 10,
      searchParams: null,
      supplModelRowShow: false,
      supplModelOptions: [],
      brand: "",
      supplModelForm: {
        termianlModel: '',
        terminalBrand: ''
      },
      loading: false
    }
  },
  created() {
    this.getList()
    api.selectBrand().then(res => {
      this.supplModelOptions = res.data
    })
  },
  mounted() {

  },
  methods: {
    queryBrand() {
      this.loading = true
      api.getModel({
        brand: this.brand,
        imei: this.supplModelForm.imei
      }).then(res => {
        this.loading = false
        const { modelMemory, productBrand } = res.data
        this.supplModelForm = {
          ...this.supplModelForm,
          termianlModel: modelMemory,
          terminalBrand: productBrand
        }
      }).finally(() => {
        this.loading = false

      })
    },
    supplModelSubmit() {
      this.loading = true
      const { order_id, termianlModel, terminalBrand } = this.supplModelForm
      api.editModel({ order_id, termianlModel, terminalBrand }).then(res => {
        this.$message.success(res.msg);
        this.loading = false
        this.supplModelRowShow = false
      }).finally(() => {
        this.loading = false

      })
    },
    tableExport() {
      api.dexindownloadAccept(this.searchParams).then(res => {
        console.log(res)
        const content = res
        const blob = new Blob([content])
        const fileName = '迪信通投保单.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    },
    query(data, cd) {
      cd();
      console.log(data, '11111111');
      if (data) {
        if (data.entryTime === null) {
          (this.beg_time = ""), (this.end_time = "");
        } else {
          this.beg_time = (data.entryTime && data.entryTime[0]) || "";
          this.end_time = (data.entryTime && data.entryTime[1]) || "";
        }
      } else {
        (this.beg_time = ""), (this.end_time = "");
      }
      this.curPage = 1
      this.getList()
    },
    currentChange(page) {
      this.curPage = page
      this.getList()
    },
    getList() {

      let params = {
        page: this.curPage,
        limit: this.pageSize,
        imei: this.imei,
        phone: this.phone,
        beg_time: this.beg_time,
        end_time: this.end_time,
        status: this.status,
      }
      this.searchParams = params
      api.dexinAcceptList(params).then(res => {
        this.tableData = res.data
        this.totalElements = res.count || 0
      })
    },
    seeDetails(row) {
      this.$router.push({
        name: '承保单详情',
        params: {
          acceptId: row.acceptId
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.account {
  /deep/ .el-form-item__label {
    width: 80px !important;
  }
}
</style>
